import React, { Component } from 'react';
import Context from './../FreactalStoreContext';
import FreactalStore from '../FreactalStore/FreactalStore';
import StateContext from './../FreactalStateContext';

export default class ProviderContainer extends Component {
  static contextType = Context;

  constructor(props) {
    super(props);
    this.store = new FreactalStore({
      ...props,
      component: this,
    });
    this.state = this.store.initializer(props);
  }

  componentDidUpdate() {
    this.store.refreshCombinedState();
  }

  render() {
    if (this.store.parent !== this.context) {
      this.store.parent = this.context;
    }

    return (
      <Context.Provider value={this.store}>
        <StateContext.Provider value={this.store.combinedState}>
          {this.props.children || ''}
        </StateContext.Provider>
      </Context.Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Provider/ProviderContainer.jsx